// extracted by mini-css-extract-plugin
export default {"contentRefWrapper":"BuyDisableAds__contentRefWrapper--8yY70"};